import { render, staticRenderFns } from "./OtherSettingsForm.vue?vue&type=template&id=0e09154b&"
import script from "./OtherSettingsForm.vue?vue&type=script&lang=js&"
export * from "./OtherSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports